<p>humidity-detail-template works!</p>
